// Lightweight cross-component signal so the sidebar credit badge (and any account view)
// can refresh right after a send/top-up, instead of waiting for the next poll.
const EVENT = "account:changed";

export function notifyAccountChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(EVENT));
  }
}

export function onAccountChanged(handler: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
